import { createContext, createImmutable } from '@rc-component/context';
var _createImmutable = createImmutable(),
  makeImmutable = _createImmutable.makeImmutable,
  responseImmutable = _createImmutable.responseImmutable,
  useImmutableMark = _createImmutable.useImmutableMark;
export { makeImmutable, responseImmutable, useImmutableMark };
var TableContext = createContext();
export default TableContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/TableContext.js
// module id = 50
// module chunks = 0